import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Trash2 } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { api, formatApiError } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { inputCls, btnSecondary, cardCls, Field } from "@/components/shared";

export const DeleteAccount = () => {
  const { user, bootstrap } = useAuth();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [value, setValue] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const confirm = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await api.post("/auth/delete-account", user.has_password ? { password: value } : { confirm: value });
      navigate("/", { replace: true });
      await bootstrap();
      toast("Your account and everything in it has been deleted");
    } catch (err) {
      setError(formatApiError(err));
      setBusy(false);
    }
  };

  return (
    <section className={`${cardCls} p-6 sm:p-8 border-t-danger/30`} data-testid="danger-zone">
      <h2 className="font-serif-display text-2xl font-semibold text-t-danger">Delete account</h2>
      <p className="text-sm text-t-muted mt-1 mb-5">Permanently remove your account and all your lists, events and notes. This can't be undone.</p>
      <button data-testid="delete-account-button" onClick={() => setOpen(true)} className={`${btnSecondary} text-t-danger`}><Trash2 className="h-4 w-4" /> Delete my account</button>
      <Dialog open={open} onOpenChange={(o) => { setOpen(o); setValue(""); setError(""); }}>
        <DialogContent aria-describedby={undefined} className="bg-t-bg border-t-line rounded-2xl sm:max-w-md" data-testid="delete-account-dialog">
          <DialogHeader><DialogTitle className="font-serif-display text-3xl font-semibold">Delete your account?</DialogTitle></DialogHeader>
          <form onSubmit={confirm} className="space-y-4">
            <p className="text-sm text-t-muted">Everything you've saved will be gone for good, including shared wishlist links.</p>
            <Field label={user.has_password ? "Enter your password to confirm" : "Type DELETE to confirm"}>
              <input data-testid="delete-account-confirm-input" type={user.has_password ? "password" : "text"} className={inputCls} value={value} onChange={(e) => setValue(e.target.value)} required />
            </Field>
            {error && <p data-testid="delete-account-error" className="text-sm text-t-danger">{error}</p>}
            <button type="submit" disabled={busy} data-testid="delete-account-confirm-button"
              className="w-full inline-flex items-center justify-center gap-2 bg-t-danger text-white font-medium px-5 py-3 rounded-xl text-sm hover:opacity-90 transition-opacity disabled:opacity-50">
              <Trash2 className="h-4 w-4" /> {busy ? "Deleting..." : "Delete forever"}
            </button>
          </form>
        </DialogContent>
      </Dialog>
    </section>
  );
};
